﻿// Collaspse Model

export interface ICollapse {
    toggleCollapse(): void;
}


export class Collapse implements ICollapse {

    expanded: boolean = false;

    toggleCollapse() {
        this.expanded = !this.expanded;
    }
}

// Collaspse Model
